import { useContext } from "react";

import { SalesSavedViewsContext } from "./sales-saved-views-provider";

export const useSalesSavedViews = () => {
  const context = useContext(SalesSavedViewsContext);

  if (context === undefined) {
    throw new Error(
      "useSalesSavedViews must be used within a SalesSavedViewsContext",
    );
  }

  return context;
};
